/** Standaard-maandverdeling voor het budgetjaar (procenten per maand), met undo. */
import React, { useEffect, useState } from 'react';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Typography } from '@mui/material';
import toast from 'react-hot-toast';
import { biedOngedaanAan } from '../../utils/ongedaan';
import { budgetApi } from './budgetApi';
import { MAANDNAMEN, naarProcenten, uitProcenten } from './budgetLogica';

export default function GewichtenDialoog({ open, jaar, gewichten, bron, versie, magWijzigen, onClose, onOpgeslagen }) {
  const [p, setP] = useState([]);
  const [bezig, setBezig] = useState(false);
  useEffect(() => { if (open) setP(naarProcenten(gewichten).map(String)); }, [open, gewichten]);

  const nieuw = uitProcenten(p);
  const som = p.reduce((s, x) => s + (Number(String(x).replace(',', '.')) || 0), 0);

  const bewaar = async (waarde, melding) => {
    setBezig(true);
    try {
      const uit = await budgetApi.gewichten({ gewichten: waarde, versie }, jaar);
      onOpgeslagen();
      onClose();
      biedOngedaanAan(melding, async () => {
        await budgetApi.gewichten({ gewichten: uit.vorige, versie: uit.versie }, jaar);
        onOpgeslagen();
      });
    } catch (e) { toast.error(e.message); } finally { setBezig(false); }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Standaard-maandverdeling {jaar}</DialogTitle>
      <DialogContent>
        <Typography sx={{ fontSize: 13.5, color: '#64748b', mb: 2 }}>
          {bron === 'ingesteld' ? 'Met de hand ingesteld.' : bron === 'facturatie'
            ? `Afgeleid uit de facturatie van ${jaar - 3} en ${jaar - 2} (gemiddeld aandeel per maand).`
            : 'Gelijk verdeeld (te weinig facturatie om uit af te leiden).'}
          {' '}Accounts zonder eigen maandbedragen volgen deze verdeling; ook de rest van {jaar - 1} in de reforecast.
        </Typography>
        <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(6, 1fr)', gap: 1 }}>
          {MAANDNAMEN.map((m, i) => (
            <TextField key={m} size="small" label={`${m} %`} value={p[i] ?? ''} disabled={!magWijzigen}
              onChange={(e) => setP((x) => x.map((v, j) => (j === i ? e.target.value : v)))} />
          ))}
        </Box>
        <Typography sx={{ fontSize: 12, color: '#94a3b8', mt: 1 }}>
          Totaal {Math.round(som * 10) / 10}% — wordt bij opslaan naar 100% geschaald.
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        {magWijzigen && bron === 'ingesteld' && (
          <Button onClick={() => bewaar(null, 'Maandverdeling terug naar afgeleid')} disabled={bezig} sx={{ textTransform: 'none', mr: 'auto' }}>
            Terug naar afgeleid
          </Button>
        )}
        <Button onClick={onClose} sx={{ textTransform: 'none' }}>{magWijzigen ? 'Annuleren' : 'Sluiten'}</Button>
        {magWijzigen && (
          <Button variant="contained" disableElevation disabled={bezig || !nieuw} onClick={() => bewaar(nieuw, 'Maandverdeling opgeslagen')}
            sx={{ textTransform: 'none', fontWeight: 700 }}>Opslaan</Button>
        )}
      </DialogActions>
    </Dialog>
  );
}
